function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="12.241" height="24" fill="currentColor" viewBox="0 0 12.241 24" {...props}><path d="M4 24V12H0V8h4V5.852C4 1.785 5.981 0 9.361 0a19.489 19.489 0 0 1 2.88.175V4H9.936C8.5 4 8 4.757 8 6.291V8h4.2l-.571 4H8v12z" /></svg>;
});